import { ErrorType } from './enum';
import { State } from './selector';

/**
 * Update flags for App container
 */
export const getUpdateFlags = (
    { isLoading, error, currentLevelId }: State,
    oldState: State,
) => ({
    loading: isLoading !== oldState.isLoading,
    initError: error !== oldState.error && error?.type === ErrorType.CmsConfig,
    level: currentLevelId !== oldState.currentLevelId,
});
